import * as AlertDialog from '@radix-ui/react-alert-dialog'
import { Bell, X } from 'lucide-react'
import { usePushSubscription } from '../hooks/usePushSubscription'
import { usePushPromptTrigger } from '../hooks/usePushPromptTrigger'

export function PushPromptDialog() {
  const push = usePushSubscription()
  const { shouldShow, recordEnabled, recordDismissed } = usePushPromptTrigger({
    pushSupported: push.isSupported,
    isSubscribed: push.isSubscribed,
    permission: push.permission,
  })

  const handleEnable = async () => {
    recordEnabled()
    await push.subscribe()
  }

  const handleDismiss = () => {
    recordDismissed()
  }

  return (
    <AlertDialog.Root
      open={shouldShow}
      onOpenChange={(open) => {
        if (!open) handleDismiss()
      }}
    >
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="fixed inset-0 bg-black/50 z-50" />
        <AlertDialog.Content className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-card border border-border rounded-lg p-6 w-[calc(100%-2rem)] max-w-sm z-50 shadow-lg">
          <button
            type="button"
            onClick={handleDismiss}
            aria-label="Close"
            className="absolute top-3 right-3 text-muted-foreground hover:text-foreground transition-colors p-1 rounded"
          >
            <X className="w-4 h-4" />
          </button>
          <div className="flex items-center gap-2 mb-2 pr-6">
            <Bell className="w-4 h-4 text-primary shrink-0" />
            <AlertDialog.Title className="text-base font-semibold">
              Turn on notifications
            </AlertDialog.Title>
          </div>
          <AlertDialog.Description className="text-sm text-muted-foreground leading-relaxed">
            Get pinged when a build fails, an app errors, or Claude needs you.
          </AlertDialog.Description>
          <div className="flex justify-center items-center gap-2 mt-5">
            <AlertDialog.Cancel asChild>
              <button
                type="button"
                onClick={handleDismiss}
                className="px-4 py-2 rounded-md hover:bg-secondary transition-colors text-sm text-muted-foreground"
              >
                Not now
              </button>
            </AlertDialog.Cancel>
            <AlertDialog.Action asChild>
              <button
                type="button"
                onClick={handleEnable}
                disabled={push.isLoading}
                className="px-4 py-2 rounded-md bg-primary text-primary-foreground hover:bg-primary/90 transition-colors text-sm font-medium disabled:opacity-50"
              >
                {push.isLoading ? 'Enabling…' : 'Enable'}
              </button>
            </AlertDialog.Action>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  )
}
